import React from 'react';
import { arrayOf, string } from 'prop-types';

import {
  CardContainer,
  Header,
  HeaderContainer,
  LoadProblem,
} from './problems-with-load.style';
import InfoTooltipButton from '../info-tooltip-button/info-tooltip-button';
import { TOOLTIP_MESSAGES } from '../../../../constants';

/**
 * The problems with load component
 * @param {object} props - Object containing the props for this component
 * @param {array} props.loadProblems - All the problems for the specified load
 * @return {element}
 */
const ProblemsWithLoad = ({ loadProblems }) => (
  <CardContainer data-testid="problems-with-load">
    <HeaderContainer>
      <Header>Problems with Load</Header>
      <InfoTooltipButton text={TOOLTIP_MESSAGES['load-problems']} />
    </HeaderContainer>
    {loadProblems.map((problem, index) => <LoadProblem key={index}>{problem}</LoadProblem>)}
  </CardContainer>
);

ProblemsWithLoad.propTypes = {
  loadProblems: arrayOf(string),
};

ProblemsWithLoad.defaultProps = {
  loadProblems: [],
};

export default ProblemsWithLoad;
